/**
 * «Провести» на НОВОМУ документі = створити, провести і відкрити створений (ч.1266).
 *
 * Тулбар документа показує «провести» і на новому документі («зберегти і провести одним
 * кліком», Закон дизайну #6). Редактор, чия дія проведення працює лише з адресою наявного
 * документа, надсилав запит з адресою «new» — користувач бачив технічну помилку
 * «doc_id must be valid UUID» (SUP-96DD97EE, списання банку).
 *
 * Якщо документ створено, а провести не вдалося, його все одно відкриваємо: інакше
 * повторне натискання створило б другий такий самий документ. Помилка проведення йде далі —
 * редактор показує її вже на відкритому документі.
 */
export async function createThenPost<D extends { id: string }, R>(
  create: () => Promise<D>,
  post: (id: string) => Promise<R>,
  opened: (doc: D) => void,
): Promise<R> {
  const doc = await create();
  try {
    return await post(doc.id);
  } finally {
    opened(doc);
  }
}
